const productSlider = document.getElementById('js-product-slider')

if (productSlider) {
  const productSliderFlkty = new Flickity('#js-product-slider', {
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    imageLoaded: true,
    lazyLoad: true,
    wrapAround: true,
    draggable: true,
  })

  // const productImages = document.querySelectorAll(".product-page__image img");
  // productImages.forEach((item) => {
  //    item.addEventListener("load", () => {
  //       imageZoom(item);
  //    })
  // });

  const sliderButtons = document.querySelectorAll(
    `.product-page__slider-button`
  )
  sliderButtons.forEach((item) => {
    item.addEventListener('click', (event) => {
      productSliderFlkty.select(parseInt(item.getAttribute('data-slide')))
    })
  })
}

const productRelatedSlider = document.querySelectorAll(
  '.js-product-related-slider'
)
if (productRelatedSlider) {
  productRelatedSlider.forEach((slider) => {
    new Flickity(slider, {
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      imageLoaded: true,
      lazyLoad: true,
      wrapAround: true,
      draggable: true,
    })
  })
}
